import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { logger } from "../../utils/logger";

const DropdownFormModal = ({
  open,
  onClose,
  onSave,
  defaultValue,
  setValue,
  defaultTamilValue,
  setTamilValue,
  isEdit,
  label,
  username,
  role,
}) => {
  // Determine if Tamil field should be shown
  const showTamilField = ["TamilMonths", "Nachathiram", "Thithi", "Utsavam"].includes(label);

  useEffect(() => {
    if (open) {
      logger.info("Dropdown modal opened", {
        action: isEdit ? "Edit" : "Add",
        label,
        username,
        role,
      });
    }
  }, [open, isEdit, label, username, role]);

  return (
    <Dialog open={open} onClose={onClose}>
      <div
        className="modal-header"
        style={{
          background: "#1976D2",
          color: "white",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px",
          borderBottom: "1px solid #ddd",
        }}
      >
        <DialogTitle>
          {isEdit ? "Edit" : "Add New"} {label}
        </DialogTitle>
        <IconButton onClick={onClose} color="dark" data-log="Close Icon Button">
          <CloseIcon sx={{ color: "white" }} />
        </IconButton>
      </div>

      <div className="modal-body" style={{ padding: "16px" }}>
        <DialogContent style={{ padding: "16px" }}>
          <TextField
            fullWidth
            label="English Value"
            value={defaultValue}
            onChange={(e) => setValue(e.target.value)}
            margin="dense"
          />

          {/* Conditionally render Tamil Value field */}
          {showTamilField && (
            <TextField
              fullWidth
              label="Tamil Value"
              value={defaultTamilValue}
              onChange={(e) => setTamilValue(e.target.value)}
              margin="dense"
              style={{ marginTop: "16px" }}
            />
          )}
        </DialogContent>
      </div>

      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "16px",
          borderTop: "1px solid #ddd",
        }}
      >
        <DialogActions>
          <Button onClick={onClose} variant="contained" color="error">
            Cancel
          </Button>
          <Button onClick={onSave} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default DropdownFormModal;
